import type { TFormProps } from "@/ui/components/form/Form";
import type { TInputProps } from "@/ui/components/form/Input";
import type { TButtonProps } from "@/ui/components/primitives/Button";
import type { SubmitEventHandler } from "react";

/*-------------------------------------
|  Constants
-------------------------------------*/

export const LOGIN_WITH_CODE_DEFAULTS = {
  noValidate: true,
} satisfies Pick<TLoginWithCodeProps, "noValidate">;

export const LOGIN_WITH_CODE_SUBMIT_DEFAULTS = {
  variant: "secondary",
  width: "fill",
} satisfies Pick<TLoginWithCodeSubmitProps, "variant" | "width">;

export const LOGIN_WITH_CODE_FIELD_CLASS = "w-full [&_[data-component='Label']]:font-sys-heading [&_[data-component='Label']]:leading-sys-1-3";

/*-------------------------------------
|  Types
-------------------------------------*/

export type TLoginWithCodeInputProps = Omit<
  TInputProps,
  | "aria-describedby"
  | "defaultValue"
  | "id"
  | "label"
  | "name"
  | "onBlur"
  | "onChange"
  | "type"
  | "value"
> & {
  value: string;
  onValueChange: (value: string) => void;
  onBlur?: () => void;
  label?: string;
};

export type TLoginWithCodeSubmitProps = Omit<
  TButtonProps,
  "children" | "type"
> & {
  label?: string;
};

export type TLoginWithCodeMessages = {
  codeLabel: string;
  codePlaceholder: string;
  submitLabel: string;
};

export type TLoginWithCodeTranslate = (
  key: keyof TLoginWithCodeMessages,
) => string;

export type TLoginWithCodeProps = Omit<
  TFormProps,
  "onSubmit"
> & {
  code: TLoginWithCodeInputProps;
  submit?: TLoginWithCodeSubmitProps;
  onSubmit: SubmitEventHandler<HTMLFormElement>;
};
